import React from 'react';
import { TableRow, TableCell, useTheme, alpha, IconButton, Box, Tooltip } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

const DataRow = ({ label, value, divider = true, onEdit, ...props }) => {
  const theme = useTheme();
  
  return (
    <TableRow {...props} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell
        component="th"
        scope="row"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: 600,
          fontSize: { xs: '0.8rem', sm: '0.875rem' },
          width: '40%',
          py: { xs: 1, sm: 1.25 },
          px: { xs: 2, sm: 3 },
          borderBottom: divider ? `1px solid ${alpha(theme.palette.text.primary, 0.08)}` : 'none'
        }}
      >
        {label}
      </TableCell>
      <TableCell
        sx={{
          color: theme.palette.text.primary,
          fontSize: { xs: '0.8rem', sm: '0.875rem' },
          py: { xs: 1, sm: 1.25 },
          px: { xs: 2, sm: 3 },
          borderBottom: divider ? `1px solid ${alpha(theme.palette.text.primary, 0.08)}` : 'none'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{value !== null && value !== undefined && value !== '' ? value : 'Not provided'}</span>
          {onEdit && (
            <Tooltip title="Edit">
              <IconButton size="small" onClick={onEdit} sx={{ ml: 1, color: theme.palette.primary.main }}>
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default DataRow;

